import { IOfferState } from '../../../../redux/reducers';

export const mapPartialRent = (offer: IOfferState) => {
  const { category } = offer;
  let { isRentByParts, rentByPartsDescription } = offer;

  // Если сдается дом целиком, не нужно передавать значение части
  if (!isRentByParts) {
    rentByPartsDescription = null;
  }

  // Только для сдачи посуточно доступна часть дома
  if (category !== 'dailyHouseRent') {
    isRentByParts = null;
    rentByPartsDescription = null;
  }

  return {
    isRentByParts,
    rentByPartsDescription,
  };
};
